import styled from 'styled-components';
import { desktop_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

export const LocationsCityListingAccordionStyles = styled.div`
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
  margin: 20px auto;
  max-width: 960px;
  padding: 20px;

  .city-accordion-title {
    background-color: #fff;
    border: none;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    text-align: left;
    width: 100%;
    -webkit-tap-highlight-color: transparent;
  }
  .accordion-chevron {
    margin-top: 110%;
  }
  .retailer-card-container {
    > div {
      margin-bottom: 20px;
    }
  }
  @media only screen and (min-width: ${desktop_breakpoint}px) {
    .retailer-card-container {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      > div {
        width: 49%;
      }
    }
  }
`;
